import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"

import { HEADER_HEIGHT_VARIABLE_NAME } from "shared/constants/app-constants"
import { useElementHeightStore } from "shared/lib/css/useElementHeightStore"
import { getDocument } from "shared/lib/getDocument"
import { scrollWindowTo } from "shared/lib/scrollWindowTo"
import usePrevious from "shared/lib/usePrevious"

import { InstallationReferenceItem } from "../BuildingReferencePageView"

interface UseScrollToInstallationReferenceArgs {
  items: InstallationReferenceItem[]
}

export function useScrollToInstallationReference({
  items
}: UseScrollToInstallationReferenceArgs) {
  const { hash } = useLocation()
  const previousHash = usePrevious(hash)
  const headerHeight = useElementHeightStore(HEADER_HEIGHT_VARIABLE_NAME)

  const didScrollRef = useRef(false)

  useEffect(() => {
    didScrollRef.current = false
  }, [hash])

  useEffect(() => {
    const elementID = hash.replace("#installation-", "")

    if (
      hash &&
      previousHash !== hash &&
      !didScrollRef.current &&
      getDocument()?.getElementById(elementID)
    ) {
      didScrollRef.current = true
      scrollWindowTo(elementID, {
        scrollBehavior: "smooth",
        offsetY: headerHeight
      })
    }
  }, [hash, previousHash, items, headerHeight])
}
